import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { getIsAuthenticated } from 'selectors/auth'

export function useIsNewMenuNavEnabled() {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const [featureFlagDecision] = useDecision('turnips_ofx_new_menu_nav')

  return isAuthenticated && featureFlagDecision.variationKey === 't1'
}
